import React from 'react';
import moment from 'moment';

//components
//import Options from '../../../../buttons/Options';

import OptionsForAll from '../../../../buttons/OptionsForAll'

//functions
import { deleteMsg } from '../../../../functions/DeleteMsg';

const ShowAllUserProjects = ({projects, profile }) => {

    // const [openDialog, setOpen] = useState(false)
    
    return (
        <div>
            {projects?.map((project, index)=>{
                if(project.ProspectContent !== ""){
                return(
                    <div
                    key={index}
                    className="bg-gray-50 rounded-lg"
                    style={{marginBottom: '10px'}}
                    >
                        <div className="px-4 py-5 sm:p-6">
                            <div style={{float: 'right'}}>
                                <OptionsForAll
                                project={project} 
                                profile={profile} 
                                deleteMsg={deleteMsg}
                                // openDialog={openDialog}
                                // setOpen={setOpen}
                                />
                            </div>
                            
                            <p 
                            style={{
                                fontWeight: 700,
                                fontSize: 15,
                                marginBottom: '5px'
                            }}
                            >
                                {project?.ProspectName}
                            </p>
                            <p 
                            className="whitespace-pre-line my-3"
                            >
                                {project?.ProspectContent}
                            </p>
                            <p className="text-gray-400 mt-2">
                                {moment.unix(project?.CreatedAt.seconds).format("MM/DD/YYYY")}
                            </p>
                        </div>  
                    </div>
                )
            } else {
                return null
            }
            })}
            
        </div>
    )
}

export default ShowAllUserProjects
